import React, { useEffect, useState } from 'react';
import { Link, usePage } from '@inertiajs/inertia-react';
import Layout from '../Shared/Layout';
import useViewport from '../Components/useViewport';
import {BiCaretDown, BiChevronRight, BiPlayCircle} from 'react-icons/bi';
import { Embed } from 'hyvor-talk-react';
import Imgix from 'react-imgix';
import AppHead from '../Shared/AppHead';
import { LibraryDrawer, DiscoverDrawer, DonateDrawer, PrayerDrawer, ReadDrawer } from "../Components/Drawers";
import { TabBar } from "../Components/TabBar";
import { FeaturedBannerSmall } from "../Components/FeaturedBannerSmall";
import List from "../Components/List/List";
import ListItem from "../Components/ListItem";

const Watch = ({
                 videoId,
                 video,
                 allChannels,
                 featuredOffers,
                 praiseReports,
                 episodes,
                 discover,
                 dgi,
                 channel,
                 terms,
                 libraryMedia,
               }) => {
  const { width } = useViewport();
  const breakpoint = 1024;
  const { imgixURL } = usePage().props;
  const [openTermsModal, setOpenTermsModal] = useState(false); 

  // Discover tab is only active on desktop
  const [activeTab, setActiveTab] = useState(
    width < breakpoint ? '' : 'discover'
  );

  // send analytics
  useEffect(() => {
    if (activeTab) {
      gtag('event', 'openWatchTab', {'event_category': 'on-demand', 'event_label': activeTab});
    }
  }, [activeTab]);

  return (
    <>
    <AppHead title={video.title} />
    
    <div className='relative mt-3'>
      <div className='container' data-theme='jpm'>
        <div className='row'>
          <div className='col-12 lg:col-8'>
            <div className='aspect-video-padding aspect-video-padding-mobile -ml-3 -mt-3 -mr-3 -mb-2
                                sm:ml-0 sm:mr-0 sm:mt-0 sm:mb-0 sm:w-full'>
            <iframe
              className='absolute top-0 bottom-0 left-0 w-full h-full'
              src={
                'https://www.youtube.com/embed/' +
                videoId +
                '?autoplay=0&enablejsapi=1&modestbranding=1&rel=0&cc_load_policy=1'
              }
              title='YouTube video player'
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
            ></iframe>
            </div>
            <div className='row mt-4 mb-4'>
              <div className='col-12'>
                <div tabIndex='0' className=''>
                  {/* <input type="checkbox" className="peer" /> */}
                  <h1 className='text-lg font-semibold p-0 pr-12 min-h-auto'>
                    {video.title}
                  </h1>
                  {video.episode_identifier && (
                    <p className='text-xs text-left text-white pb-1'>
                      {video.episode_identifier_string}
                    </p>
                  )}
                  <p className='text-xs text-neutral-content'>
                    {video.youtube_published_at}
                  </p>
                  <p className="text-sm px-0 py-1 whitespace-pre-wrap">
                    {video.description ?? ''}
                  </p>
                </div>
                {episodes && episodes.length > 1 && (
                  <>
                    {/* desktop */}
                    <div className='hidden md:flex mt-3'>
                      {episodes.map((part, index) =>
                        part.part_number === video.part_number ? (
                          <div className='btn btn-outline btn-primary mr-3 border' key={index}>
                            Part {part.part_number}{' '}
                            <BiPlayCircle className='inline-block pl-1' />
                          </div>
                        ) : (
                          <Link
                            key={index}
                            className='btn btn-outline mr-3 border'
                            href={`/on-demand/watch/${part.slug}`}
                          >
                            Part {part.part_number}
                          </Link>
                        )
                      )}
                    </div>

                    {/* mobile */}
                    <div className='float-right dropdown dropdown-end md:hidden m-0 mt-2'>
                      <label
                        tabIndex='0'
                        className='m-0 bg-secondary rounded-[3px] p-2 mt-1 text-white text-sm font-bold'
                      >
                        Part {video.part_number}{' '}
                        <BiCaretDown className='pl-1 inline-block' />
                      </label>
                      <ul
                        tabIndex='0'
                        className='dropdown-content menu p-2 shadow bg-neutral rounded-lg w-36 !z-[1001]'
                      >
                        {/* <li><a>Item 1</a></li>
                                                <li><a>Item 2</a></li> */}
                        {episodes.map((part, index) =>
                          part.part_number === video.part_number ? (
                            <li key={index} className='bg-secondary'>
                              <div className='rounded text-right'>
                                Part {part.part_number}{' '}
                                <BiPlayCircle
                                  className='inline-block'
                                  size='24px'
                                />
                              </div>
                            </li>
                          ) : (
                            <li key={index}>
                              <Link
                                href={`/on-demand/watch/${part.slug}`}
                                className='text-right'
                              >
                                Part {part.part_number}
                              </Link>
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="row mt-4 mb-4">
              <div className="col-12">
                <div className="row">
                  <div className="col-12 flex-col justify-center">
                    <div className="bg-gray-800 p-2 w-full text-sm">
                      If you are experiencing technical difficulties while watching the video, <a className="text-primary" href={`https://youtu.be/`+videoId} target="_blank">click here to watch it on YouTube</a>.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* for non jpm videos, show channel */}
            {channel.slug && (
              <div className='row mt-4 mb-4'>
                <div className='col-12'>
                  <div className='w-full mb-4 border-t border-solid border-[#7D7D7D]'></div>
                  <div className='row'>
                    <div className='col-2 md:col-1'>
                      <Link
                        href={'/on-demand' + channel.slug}
                        className='avatar'
                      >
                        <div className='w-10 md:w-full rounded-full'>
                          <Imgix
                            className='w-full'
                            sizes='(min-width: 1280px) 56px, (min-width: 1024px) 56px, (min-width: 768px) 36px, (min-width: 640px) 48px, 48px'
                            src={video.channel.large_thumbnail_url}
                            alt={channel.title}
                          />
                        </div>
                      </Link>
                    </div>
                    <div className='col-10 md:col-11 flex-col justify-center'>
                      <Link
                        href={'/on-demand' + channel.slug}
                        className='text-base font-semibold pt-1'
                      >
                        {channel.title}
                      </Link>
                      <Link
                        href={'/on-demand' + channel.slug}
                        className='block text-primary text-sm'
                      >
                        More from this channel
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className='md:hidden'>
              <div className='w-full'>
                <div className='flex items-center justify-between mb-4'>
                  <h2 className='text-xl font-bold'>Featured Offers</h2>
                  <a href={'/offers'}>
                    <BiChevronRight size="24px"/>
                  </a>
                </div>
                <List
                    elements={featuredOffers}
                    totalElements={featuredOffers.length}
                    viewportWidth={789}
                    listItem={el => (
                        <ListItem
                            imageUrl={`https://${imgixURL}/${el.cover_image}`}
                            heading={'Featured Offer'}
                            title={el.title}
                            isHorizontalScroll={true}
                            description={el.shortDescription}
                            link={el.link}
                        />)}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <div className='w-full mt-4 mb-4 border-t border-solid border-[#7D7D7D]'></div>
                <h2 className="text-lg font-semibold text-left md:text-center mb-1">Share your thoughts with <br
                    className="md:hidden"/>our community</h2>
                {terms && (
                    <p className="text-sm text-neutral-content text-left md:text-center">By sharing your comment, you
                      are agreeing to the following <a href="#" onClick={() => setOpenTermsModal(true)}
                                                       className="border-b-primary border-b b-solid">terms and
                        conditions</a>.</p>
                )}
              </div>
            </div>
            <div className='row mb-4'>
              <div className='col-12'>
                <Embed
                  websiteId={'7171'}
                  id={
                    video.episode_identifier && video.episode_identifier !== 'n/a'
                      ? 'ep' + video.episode_identifier
                      : videoId
                  }
                />
              </div>
            </div>
          </div>

        {/* Terms Modal */}
        {terms && (
            <div className={`modal z-[100000] ` + (openTermsModal ? 'modal-open' : '')} onClick={() => setOpenTermsModal(false)} style={{backgroundColor: 'rgba(40,40,42,0.8)'}}>
                    <div className="modal-box max-w-md relative bg-neutral rounded p-0 mt-2 md:mt-0" onClick={() => setOpenTermsModal(false)}>
                    <button onClick={() => setOpenTermsModal(false)} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent border-none">✕</button>
                    <div className="p-4">
                        <h2 className="text-xl font-bold mb-4">{terms.title}</h2>
                        <div className="text-sm prose" dangerouslySetInnerHTML={{__html: terms.content}}>
                        </div>
                    </div>
                </div>
            </div>
        )}

          {/* desktop right , mobile tabs */}
          <div className='col-12 lg:col-4'>
            <div className='hidden md:flex'>
              <div className='w-full'>
                <div className='flex items-center justify-between'>
                  <h2 className='text-xl font-bold'>Featured Offers</h2>
                  <a href={'/offers'}>
                    <BiChevronRight size="24px"/>
                  </a>
                </div>
                <List
                    elements={featuredOffers}
                    totalElements={featuredOffers.length}
                    width={featuredOffers.length > 1 ? 'w-1/2' : 'w-full'}
                    viewportWidth={789}
                    listItem={el => (
                        <ListItem
                            imageUrl={`https://${imgixURL}/${el.cover_image}`}
                            heading={'Featured Offer'}
                            title={el.title}
                            isHorizontalScroll={true}
                            description={el.shortDescription}
                            link={el.link}
                        />)}
                />
              </div>
            </div>
            <div className='rounded border border-[#373737] md:h-0 lg:h-auto'>
              <TabBar activeTab={activeTab} setActiveTab={setActiveTab}/>
              <ReadDrawer
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  praiseReports={praiseReports}
                  dgi={dgi}
              />
              <PrayerDrawer activeTab={activeTab} setActiveTab={setActiveTab}/>
              <DiscoverDrawer
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  items={discover}
              />
              <DonateDrawer activeTab={activeTab} setActiveTab={setActiveTab}/>
              <LibraryDrawer
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  libraryItems={libraryMedia}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

// Persistent layout Docs: https://inertiajs.com/pages#persistent-layouts
Watch.layout = (page) => (
  <Layout title='Watch' children={page} data-theme='jpm' />
);

export default Watch;
